import { Component, AfterViewInit, Input } from '@angular/core';

@Component({
	selector: 'modified-by',
	template: `{{modifiedBy}} `
})
export class ModifiedByComponent implements AfterViewInit {

	constructor() { }

	@Input() entityType: string;

	@Input() entityId: any;

	ngAfterViewInit(): void { }

	modifiedBy: string = "test";
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/shared/audit/modified-by.component.ts